"use client";

import React, { useRef, useState, useEffect } from "react";

import Image from "next/image";
import CornerChip from "@/components/global/ui/CornerChip";

import { cn } from "@/lib/utils";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { CTACornerButton } from "@/shadcn/ui/corner-button";
import {
  HLSVideoPlayer,
  SanityVideoPlayer,
} from "@/components/ui/SanityVideoPlayer";
import { Dialog, DialogContent } from "@/shadcn/ui/dialog";

import { PageAboutSchema } from "@/sanity/pages/PageAboutTemplate";

import volumeMute from "@/public/icons/Volume--mute--filled.svg";
import volumeUnmute from "@/public/icons/Volume--up--filled.svg";
import maximize from "@/public/icons/Maximize.svg";
import screenEffect from "@/public/about/screen-effect.svg";
import { PageInnerCircleSchema } from "@/sanity/pages/PageInnerCircleTemplate";
import Chip from "../global/ui/Chip";
import Divider from "../global/ui/Divider";
import DividerGreenLine from "../global/ui/DividerGreenLine";
import ChipScrollingBanner from "../global/ui/ChipScrollingBanner";
import GridNoise from "../global/ui/GridNoise";
import CardGrid from "./CardGrid";

export default function WhatSection({
  data,
  className,
}: {
  data: PageInnerCircleSchema;
  className?: string;
}) {
  return (
    <section
      className={cn(
        "relative flex pb-[12rem] lg:pb-[20rem] px-[2rem] lg:px-0 bg-white",
        className,
      )}
    >
      <div className="relative flex flex-col items-center w-full">
        {data?.whatTitle && (
          <div className="richtext richtext-center prose-headings:not-italic prose-headings:text-black prose-headings:text-[6rem] lg:prose-headings:text-[7rem] prose-headings:font-ivy prose-p:text-white/60 mb-[4rem] lg:mb-[5rem]">
            <PortableText
              value={data.whatTitle}
              components={richTextComponent}
            />
          </div>
        )}

        {data.whatList && (
          <CardGrid
            cards={data.whatList}
            className="w-[min(183rem,100%)] mb-[2rem]"
          />
        )}

        {data.whatCTA && (
          <div className="w-[40rem]">
            <CTACornerButton data={data.whatCTA} />
          </div>
        )}
      </div>
    </section>
  );
}
